<template>
	<div data-tour-scope="brands-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.brands') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->

								<!-- <v-divider vertical></v-divider>-->
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn v-if="!magento" elevation="0" text title="Aggiungi marca" data-tour="add-brand" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
								<v-menu v-else bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item @click="getCategoryMagento" v-if="magento">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa da Magento</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item data-tour="add-brand" @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi marca</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getBrands"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"
                            :class="{mobile: isMobile}"-->

							<!-- <template slot="headers" slot-scope="props">
                                 <tr>
                                     <th>
                                         <v-checkbox
                                                 primary
                                                 hide-details
                                                 @click.native="toggleAll"
                                                 :input-value="props.all"
                                                 :indeterminate="props.indeterminate"
                                         ></v-checkbox>
                                     </th>
                                     <th v-for="header in props.headers" :key="header.text"
                                         :class="['column sortable', settings.pagination.descending ? 'desc' : 'asc', header.value === settings.pagination.pagination.sortBy ? 'active' : '']"
                                         @click="changeSort(header.value)"
                                     >
                                         <v-icon>arrow_upward</v-icon>
                                         {{ header.text }} f
                                     </th>
                                 </tr>
                             </template>-->
							<template v-slot:body="{ items }">
								<!-- telefono: ogni brand diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="brand-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="(item.trans && item.trans.name) || 'Brand'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center mb-2">
													<span class="brand-label mr-2">Lingue</span>
													<LingueFlags :lingue="item.lingue" />
												</div>
												<div class="d-flex align-center justify-space-between" data-tour="status">
													<span class="brand-label">Attivo</span>
													<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
													<!-- <v-list-item link @click="moveItem(item)">
                                             <v-list-item-title class="size9">Sposta reference</v-list-item-title>
                                         </v-list-item>
                                         <v-list-item link @click="copyItem(item)">
                                             <v-list-item-title class="size9">Copia reference</v-list-item-title>
                                         </v-list-item>-->
												</v-list>
											</v-menu>
										</td>
										<td data-tour="status">
											<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
										<td>
											{{ item.created_at | moment('DD/MM/YYYY') }}
										</td>

										<!--<td>{{ item.id}}</td>-->

										<td>{{ item.trans.name }}</td>
										<td>{{ item.url }}</td>
										<td>{{ item.references }}</td>
										<td data-tour="langs"><LingueFlags :lingue="item.lingue" /></td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<!--<v-btn
                            fab
                            bottom
                            right
                            color="secondary"
                            dark
                            fixed
                            @click.prevent="openNew()"
                    >

                        <v-icon>add</v-icon>
                    </v-btn>-->
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando le marche non potrai più ripristinarle. </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';

Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import LingueFlags from '@/components/core/LingueFlags.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createBrandsListTourSteps, stopBrandsListTour } from './brands-list-tour';
import { listRouteState } from '@/components/core/list/listRouteState';

// sotto i 4 caratteri il backend ignora la ricerca
const SEARCH_MIN = 4;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Brand',
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createBrandsListTourSteps(), { onStop: stopBrandsListTour }),
		};
	},
	data() {
		return {
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',

			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,

			searchfield: '',

			total: 0,

			headers: [
				// colonna del menu a tre puntini: non si ordina (ordinava per un campo vuoto e la lista restava in caricamento)
				{ text: '', value: '', sortable: false },
				{ text: 'Status', value: 'is_active' },
				{ text: 'Created', value: 'created' },

				//{text: 'Id', value: 'id'},

				{ text: 'Brand', value: 'trans.name' },
				{ text: 'Url', value: 'url' },
				{ text: 'Reference', value: 'references' },
				// una bandierina per lingua: a colori dove il nome c'e', in grigio dove manca
				{ text: 'Lingue', value: 'lingue', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},

			firstLevel: [],
			secondLevel: [],
			thirdLevel: [],
			fourthLevel: [],
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',

			isMobile: false,

			magento: false,
			langDefault: '',
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			menu: false,
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},
	created() {
		//this.setDialog(false)
		//this.initialize();

		this.setExistFilter(true);
		this.listLoad();
		this.linkdownload = `${this.getUrl}categories/download`;

		/*console.log(this.getSettings)
            this.langDefault = _.find(this.getSettings.languages, {default: true}).lang

            var magento = _.find(this.getSettings.settings, {service: "magento"})
            if (magento) {
                this.magento = magento.active
            }*/
		this.fetchSetting().then(data => {
			this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;

			//this.items = this.getSettings.categories
			/*  var magento = _.find(data.settings, {service: "magento"})
                if (magento) {
                    this.magento = magento.active
                }*/
		});
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		LingueFlags,
		TourOverlay,
		KeyValueCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'categories/getIndex',
			getBrands: 'brands/getBrands',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'brands/getSortBy',
			getSortDesc: 'brands/getSortDesc',

			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		// stessi dati delle colonne Created/Url/Reference della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Url', value: item.url },
				{ label: 'Reference', value: item.references },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setBrands: 'brands/setBrands',
			setBrand: 'brands/setBrand',
			setIndex: 'brands/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'brands/asyncFetchData',

			destroyData: 'brands/destroyData',
			saveData: 'users/saveData',

			setUpdateStatusBrand: 'brands/setUpdateStatusBrand',
			deleteBrands: 'brands/deleteBrands',
			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		filterCheck(event) {
			var dot = _.map(event, 'id');

			this.settings.filters.categories = dot;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggleDrawerSort() {
			this.setDrawerFilter(0);
			this.clippedOrder = !this.clippedOrder;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		changeStatus(item) {
			try {
				this.setPreload(true);
				this.isActive = true;

				let items = this.setUpdateStatusBrand({ _id: item._id, is_active: item.is_active }).then(result => {
					//this.total = result.total
					//this.items = result.data.data
					if (result.data.data.ok) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async getCategoryMagento() {
			this.setPreload(true);
			await this.getFetchCategoryMagento();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Le marche verranno caricate in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},

		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		// inserimento e modifica sono pagine (si apre solo dalla riga, tre puntini):
		// la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/brands/${item._id}`);
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/brands/new');
		},
		// ritorna la promessa: confirmDelete aspetta il ricaricamento prima del messaggio
		getDataFromApi() {
			this.setPreload(true);
			this.isActive = true;
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result.total;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {},

		deleteItem(item = null) {
			this.dialogconfirm = true;

			if (item) {
				this.form = item;
			}
		},
		confirmDelete() {
			this.dialogconfirm = false;
			// solo la marca scelta dai tre puntini: niente piu' eliminazione multipla
			const paypload = this.form && this.form._id ? _.filter(this.getBrands, { _id: this.form._id }) : [];
			if (paypload.length) {
				this.setPreload(true);
			}
			this.deleteBrands(paypload)
				.then(data => {
					this.setPreload(false);

					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.brand-cards,
.brand-cards tr {
	display: block;
	width: 100%;
}
.brand-cards tr,
.brand-cards tr:hover {
	background: transparent !important;
}
.brand-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.brand-cards tr:first-child td {
	padding-top: 12px !important;
}
.brand-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.brand-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
